export default function loadingButtonDirective() {
  'ngInject';
  return {
    restrict: 'E',
    scope: {
      loading: '=',
      loadingText: '@',
      class: '@'
    },
    replace: true,
    transclude: true,
    link: function($scope){
      $scope.loadingText = $scope.loadingText || "Processing...Please wait.";
    },
    template: `
      <button class="{{class}}", ng-class="{loading: loading}" , ng-disabled="loading">
        <span ng-show="loading">{{loadingText}}</span>
        <ng-transclude ng-hide="loading"></ng-transclude>
        <span class="spinning-loader icon-loading" ng-show="loading"></span>
      </button>
    `
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/shared/directives/loadingButton/loadingButton.directive.js
 **/